export const posterProgressPercent = (qualifiedPosters: number, postersThreshold: number): number =>
    postersThreshold > 0 ? Math.min(100, Math.max(0, Math.floor((qualifiedPosters / postersThreshold) * 100))) : 0;

export const postersThresholdOf = (lenses: readonly { postersThreshold?: number | null }[]): number | null =>
    lenses.map((lens) => lens.postersThreshold ?? 0).find((threshold) => threshold > 0) ?? null;
